<template>
  <div id="Socialmedia">
    <div class="social-media">
      <a
        class="fab fa-facebook"
        href="https://www.facebook.com/michellealvarezbeaman/"
        target="_blank"
      >
      </a>
      <a
        class="fab fa-instagram"
        href="https://www.instagram.com/mitchalvarez30/"
        target="_blank"
      >
      </a>
    </div>
  </div>
</template>

<script>
import db from '../../config/db'

export default {
  name: 'media',
  data () {
    return {
      files: ''
    }
  },
  methods: {
    storeFiles () {
      const fileInfo = this.$refs.myFiles.files[0]
      db.storing.ref(
        'camera/' +
        fileInfo.name.split('.')[0] +
        '-' +
        fileInfo.lastModified
      ).put(fileInfo)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/common.scss";

.social-media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 20px;
  a {
    margin: 0 10px 0 0;
    color: $media-colour;
    font-size: 2rem;
    text-decoration:none;
  }
}

label.cameraButton {
  padding-right: 15px;
  margin: 0 10px 0 0;
  color: $media-colour;
  font-size: 2rem;
  text-decoration:none;
  cursor: pointer;

  input {
    display: none;
  }
}

</style>
